import { render, staticRenderFns } from "./ErpDlsReturnsXiu.vue?vue&type=template&id=46cb2b1c&scoped=true&"
import script from "./ErpDlsReturnsXiu.vue?vue&type=script&lang=js&"
export * from "./ErpDlsReturnsXiu.vue?vue&type=script&lang=js&"
import style0 from "./ErpDlsReturnsXiu.vue?vue&type=style&index=0&id=46cb2b1c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46cb2b1c",
  null
  
)

export default component.exports